export class NoImagesException extends Error {
  constructor() {
    super('No images provided for image slider');
  }
}
